import React, { useState } from 'react';

export default function ViolationHistory({ violations }) {
  const [showAll, setShowAll] = useState(false);
  
  const getSeverityColor = (severity) => {
    const colors = {
      'high': 'danger',
      'medium': 'warning',
      'low': 'info'
    };
    return colors[severity] || 'secondary';
  };

  const getViolationIcon = (violationType) => {
    const icons = {
      'TAB_SWITCH': 'exchange-alt',
      'FULLSCREEN_EXIT': 'expand-arrows-alt',
      'DEVELOPER_TOOLS_ATTEMPT': 'code',
      'RESTRICTED_ACTION': 'ban',
      'COPY_PASTE_ATTEMPT': 'copy',
      'WINDOW_BLUR': 'eye-slash',
      'MULTIPLE_FACES_DETECTED': 'users',
      'NO_FACE_DETECTED': 'user-times'
    };
    return icons[violationType] || 'exclamation-triangle';
  };

  const getViolationTitle = (violationType) => {
    const titles = {
      'TAB_SWITCH': 'Tab Switch',
      'FULLSCREEN_EXIT': 'Fullscreen Exit',
      'DEVELOPER_TOOLS_ATTEMPT': 'Dev Tools Access',
      'RESTRICTED_ACTION': 'Restricted Action',
      'COPY_PASTE_ATTEMPT': 'Copy/Paste Attempt',
      'WINDOW_BLUR': 'Window Focus Lost',
      'MULTIPLE_FACES_DETECTED': 'Multiple Faces',
      'NO_FACE_DETECTED': 'No Face Detected'
    };
    return titles[violationType] || violationType;
  };

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString();
  };

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const then = new Date(timestamp);
    const diffInSeconds = Math.floor((now - then) / 1000);
    
    if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
    
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    return `${diffInHours}h ${diffInMinutes % 60}m ago`;
  };

  const displayedViolations = showAll ? violations : violations.slice(0, 10);
  const hasMore = violations.length > 10;

  return (
    <div className="card">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0">
            <i className="fas fa-exclamation-triangle text-danger me-2"></i>
            Recent Violations ({violations.length})
          </h6>
          {hasMore && (
            <button
              type="button"
              className="btn btn-link btn-sm p-0"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? 'Show Less' : 'Show All'}
            </button>
          )}
        </div>
      </div>
      <div className="card-body p-0" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {violations.length === 0 ? (
          <div className="text-center py-4">
            <i className="fas fa-shield-alt text-success" style={{ fontSize: '48px' }}></i>
            <p className="text-muted mt-2 mb-0">No violations detected</p>
            <small className="text-muted">All participants are following exam rules</small>
          </div>
        ) : (
          <div className="violation-list">
            {displayedViolations.map((violation, index) => (
              <div key={index} className="violation-item">
                <div className="violation-header">
                  <div className="d-flex align-items-center">
                    <i className={`fas fa-${getViolationIcon(violation.violation_type)} me-2 text-${getSeverityColor(violation.severity)}`}></i>
                    <strong className="violation-title">
                      {getViolationTitle(violation.violation_type)}
                    </strong>
                    <span 
                      className={`badge bg-${getSeverityColor(violation.severity)} ms-auto`}
                    >
                      {violation.severity?.toUpperCase() || 'LOW'}
                    </span>
                  </div>
                  <small className="text-muted d-block mt-1">
                    {violation.participant_name || `User ${violation.user_id}`} • {getTimeAgo(violation.timestamp)}
                  </small>
                </div>
                
                {violation.violation_details && (
                  <div className="violation-details">
                    <small className="text-muted">
                      {typeof violation.violation_details === 'string' 
                        ? violation.violation_details 
                        : JSON.stringify(violation.violation_details)
                      }
                    </small>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <style jsx>{`
        .violation-list {
          padding: 0;
        }
        
        .violation-item {
          padding: 12px 16px;
          border-bottom: 1px solid #dee2e6;
          transition: background-color 0.2s ease;
        }
        
        .violation-item:hover {
          background-color: #f8f9fa;
        }
        
        .violation-item:last-child {
          border-bottom: none;
        }
        
        .violation-header {
          margin-bottom: 4px;
        }
        
        .violation-title {
          font-size: 14px;
          color: #343a40;
        }
        
        .violation-details {
          background: #f8f9fa;
          padding: 6px 8px;
          border-radius: 4px;
          margin-top: 6px;
          border-left: 3px solid #dee2e6;
        }
        
        .violation-details small {
          font-size: 11px;
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
}
